import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { gameCredits, filmCredits } from "../data/mock";

const Work = () => {
  return (
    <div className="bg-[#f4f1ec] text-black">
      <section className="pt-32 md:pt-40 pb-12">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <span className="text-xs uppercase tracking-[0.22em] text-neutral-500">
            Work
          </span>
          <h1
            className="mt-4 text-4xl md:text-6xl lg:text-7xl tracking-tight font-medium leading-[1.05]"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Selected scores &amp; sound design.
          </h1>
          <p className="mt-6 text-neutral-700 max-w-2xl text-lg leading-relaxed">
            Two ways to explore the work — cinematic compositions for video
            games and original music written to the screen.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <Link
            to="/work/game-credits"
            className="group relative aspect-[4/5] md:aspect-[4/5] overflow-hidden rounded-md shadow-xl bg-neutral-900"
          >
            <img
              src={gameCredits.projects[0].image}
              alt="Game Credits"
              className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-60 transition-all duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-8 md:p-10 text-white">
              <span className="text-xs uppercase tracking-[0.22em] text-white/70">
                01 — Games
              </span>
              <h2
                className="mt-3 text-3xl md:text-5xl font-medium tracking-tight flex items-center gap-3"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                Game Credits
                <ArrowUpRight className="w-7 h-7 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </h2>
              <p className="mt-3 text-white/80 max-w-md">
                Cinematic composer for video games &amp; VR. Multiple Meta Top
                10 titles.
              </p>
            </div>
          </Link>

          <Link
            to="/work/film-credits"
            className="group relative aspect-[4/5] md:aspect-[4/5] overflow-hidden rounded-md shadow-xl bg-neutral-900"
          >
            <img
              src={filmCredits.posters[3]}
              alt="Film Credits"
              className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-60 transition-all duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-8 md:p-10 text-white">
              <span className="text-xs uppercase tracking-[0.22em] text-white/70">
                02 — Film
              </span>
              <h2
                className="mt-3 text-3xl md:text-5xl font-medium tracking-tight flex items-center gap-3"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                Film Credits
                <ArrowUpRight className="w-7 h-7 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </h2>
              <p className="mt-3 text-white/80 max-w-md">
                Documentary, feature film, and short film scoring.
              </p>
            </div>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Work;
